<template>
	<div v-bind:class="['tooltip', { inverted } ]"
		 v-bind:style="(display) ? {
			 display: display.display,
			 left: display.left + ((inverted && this.width) ? (display.width - this.width) : 0) + 'px',
			 top: display.top + 'px',
			 width: (this.width || display.width) + 'px',
			 marginTop: tooltipTopOffset
		 } : {
			 display: 'none'
		 }"
		 @mouseover="showTooltip"
		 @mouseout="hideTooltip">
		<div class="scroll"><slot></slot></div>
	</div>
</template>

<script>
export default {
	name: 'graph-tooltip',

	props: {
		/**
		 * @prop 	display
		 * @type 	Object
		 * @desc	'display' object of tooltip indicating the status of display for tooltip
		 * @required
		 */
		display: {
			type: Object
		},
		/**
		 * @prop 	width
		 */
		width: {
			type: Number
		}
	},

	mounted() {
		if (this.display && this.width) {
			this.display.width = this.width
		}
	},

	computed: {
		/**
		 * @function 	inverted
		 * @desc		If the tooltip is going out of screen then set to true
		 */
		inverted() {
			if (typeof this.display === 'object' &&
				this.display.display == 'block' &&
				this.display.left + this.display.width >= window.innerWidth) {
				return true
			}
			return false
		},

		/**
		 * @function 	tooltipTopOffset
		 * @desc		Find the tooltip offset form top to fit it in the view
		 */
		tooltipTopOffset() {
			if (typeof this.display === 'object' &&
				this.display.display == 'block' &&
				this.display.top + 310 >= window.innerHeight) {
				return -1 * (this.display.top + 310 - window.innerHeight);
			}
			return 0
		}
	},

	methods: {
		/**
		 * @function 	showTooltip
		 * @desc		show the tooltip by calling the parent components' method 'hover' with argument as 'true'
		 */
		showTooltip() {
			this.$emit('hover', true);
		},

		/**
		 * @function 	hideTooltip
		 * @desc		hide the tooltip by calling the parent components' method 'hover' with argument as 'false'
		 */
		hideTooltip() {
			this.$emit('hover', false);
		}
	}
}
</script>

<style lang="scss" scoped>
$primary-color: rgb(42, 66, 77);

.tooltip {
	width: 200px;
	max-height: 300px;
	background-color: $primary-color;
	color: #ffffff;
	font-size: 10pt;
	margin-top: 5px;
	margin-left: 20px;
	position: fixed;
	display: none;
	z-index: 99999;
	border-radius: 5px;

	.scroll {
		overflow-y: auto;
		max-height: 300px;
		padding: 5px 10px;

		p {
			margin: 5px;
		}
	}
}
.tooltip.inverted {
	margin-left: -240px;
}
.tooltip::before {
	content: "";
	position: absolute;
	top: 15px;
	width: 0;
	height: 0;
	border-top: 8px solid transparent;
	border-bottom: 8px solid transparent;
}
.tooltip:not(.inverted)::before {
	content: "";
	left: -8px;
	top: 10px;
	border-right: 8px solid $primary-color;
}
.tooltip.inverted::before {
	content: "";
	right: -8px;
	border-left: 8px solid $primary-color;
}
</style>
